<template>
  <div class="saved-view-title-editor">
    <icon-picker
      :icon="buildIcon(emoji, iconType.icon)"
      show-placeholder
      size="3.2rem"
      :icon-size="16"
      bordered
      :disabled="disabled"
      :show-icon-variants="false"
      :icon-types="[iconType.icon]"
      class="_emoji-picker"
      @change="setEmoji"
    />
    <m-text-field
      v-model:value="title"
      auto-focus
      :disabled="disabled"
      :placeholder="$t('savedViewSelector.addViewPlaceholder')"
      @keydown.enter="submit"
      @blur="submit"
    />
  </div>
</template>

<script>
import IconPicker from '@/components/IconPicker.vue';
import useDebounce from 'shared/composables/debounce';
import { buildIcon } from 'shared/lib/icon';
import { iconType } from 'shared/constants.json';

export default {
  name: 'SavedViewTitleEditor',
  props: {
    entity: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update'],
  components: { IconPicker },
  setup() {
    const { debounce } = useDebounce({ onBeforeUnmountFlush: true });
    return { debounce };
  },
  data() {
    return {
      title: '',
      emoji: null,
      iconType,
    };
  },
  methods: {
    buildIcon,
    setEmoji(emoji) {
      this.emoji = emoji.value;
    },
    submit() {
      if (this.title === this.entity.title) {
        return;
      }
      this.updateDebounced();
    },
    emitUpdate() {
      const view = {
        uid: this.entity.uid,
        isTemp: this.entity.isTemp,
        title: this.title,
        emoji: this.emoji,
      };

      this.$emit('update', view);
    },
    updateDebounced(wait = 0) {
      const fn = () => this.emitUpdate();
      this.debounce(fn, wait);
    },
  },
  watch: {
    title(newVal, oldVal) {
      if (newVal === oldVal || oldVal === '') {
        return;
      }
      this.updateDebounced(800);
    },
    emoji(newVal, oldVal) {
      if (newVal === oldVal || oldVal === null) {
        return;
      }
      this.updateDebounced();
    },
  },
  created() {
    this.title = this.entity.title;
    this.emoji = this.entity.emoji;
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .saved-view-title-editor {
    display: flex;
    padding: 1.2rem;

    ._emoji-picker {
      margin-right: .8rem;
    }
  }
</style>
